if (!customElements.get('see-similar-modal')) {
  class SeeSimilarModal extends HTMLElement {
    constructor() {
      super();

      this.overlay = this.querySelector('.see-similar-modal__overlay');
      this.dialog = this.querySelector('.see-similar-modal__dialog');
      this.closeBtn = this.querySelector('.see-similar-modal__close');
      this.slider = this.querySelector('#Slider-similar-modal');
      this.loadingEl = this.querySelector('.see-similar-modal__loading');
      this.hasCards = false;
      this.renderedCards = null;

      this.close = this.close.bind(this);
      this.open = this.open.bind(this);

      if (this.overlay) this.overlay.addEventListener('click', this.close);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);

      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' || (event.code && event.code.toUpperCase() === 'ESCAPE')) {
          this.close();
        }
      });

      this.initSwipeToDismiss();
    }

    connectedCallback() {
      // Reparent to document.body so fixed positioning is relative to viewport,
      // not constrained by any parent transform (e.g. scroll-reveal animations).
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    open() {
      this.setAttribute('open', '');
      this.classList.add('is-open');
      this.removeAttribute('hidden');

      document.body.classList.add('overflow-hidden');

      const fixedBtns = document.querySelector('.product_form_fixed_buttons');
      if (fixedBtns) {
        fixedBtns.style.display = 'none';
      }

      // Check if recommendations cards are already available in memory
      if (!this.hasCards && window.similarProductsCards && window.similarProductsCards.length) {
        this.setCards(window.similarProductsCards);
      }

      // Reset and recalculate slider pages once visible
      requestAnimationFrame(() => {
        const customSliderModal = this.querySelector('slider-component');
        if (customSliderModal) {
          if (typeof customSliderModal.initSlider === 'function') {
            customSliderModal.initSlider();
          }
          if (typeof customSliderModal.resetPages === 'function') {
            customSliderModal.resetPages();
          }
        }
      });
    }

    close() {
      this.removeAttribute('open');
      this.classList.remove('is-open');

      document.body.classList.remove('overflow-hidden');

      const fixedBtns = document.querySelector('.product_form_fixed_buttons');
      if (fixedBtns) {
        fixedBtns.style.display = 'block';
      }

      if (this.dialog) {
        this.dialog.style.transform = '';
      }
    }

    setCards(cards) {
      if (!cards || !cards.length || !this.slider) return;
      if (this.renderedCards === cards && this.hasCards) return;

      this.renderedCards = cards;
      this.slider.innerHTML = '';
      cards.forEach((prod, index) => {
        const item = document.createElement('li');
        item.className = 'grid__item slider__slide';
        item.id = `Slide-similar-modal-${index}`;
        item.innerHTML = prod;
        this.slider.appendChild(item);
      });

      this.hasCards = true;

      if (this.loadingEl) {
        this.loadingEl.hidden = true;
        this.loadingEl.style.display = 'none';
      }

      const customSliderModal = this.querySelector('slider-component');
      if (customSliderModal) {
        if (typeof customSliderModal.initSlider === 'function') {
          customSliderModal.initSlider();
        }
        if (typeof customSliderModal.resetPages === 'function') {
          customSliderModal.resetPages();
        }
      }

      if (typeof executeScripts === 'function') {
        executeScripts(this.slider);
      }

      if (typeof checkTransitions === 'function') {
        checkTransitions();
      }
    }

    initSwipeToDismiss() {
      if (!this.dialog) return;

      let startY = 0;
      let currentY = 0;
      let isDragging = false;

      const header = this.querySelector('.see-similar-modal__header');
      const target = header || this.dialog;

      target.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      target.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;
        if (deltaY > 0) {
          this.dialog.style.transform = `translateY(${deltaY}px)`;
          this.dialog.style.transition = 'none';
        }
      }, { passive: true });

      target.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const deltaY = currentY - startY;
        this.dialog.style.transition = '';
        if (deltaY > 70) {
          this.close();
        } else {
          this.dialog.style.transform = '';
        }
      }, { passive: true });
    }
  }

  customElements.define('see-similar-modal', SeeSimilarModal);
}
